import { createFileRoute } from '@tanstack/react-router';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/webdesigned/_layout')({
  component: WebDesignedPortal,
});
